import React, { Component } from 'react';
import './Masthead.css';


export default class Element extends Component {

    componentDidMount() {
        require('../../js/external/twitter.js')();
    }

    render() {

        return (
            <div className="Masthead">
                <div className="Masthead__item">
                    <span className="Masthead__label white">Conçu, écrit et réalisé par</span>
                    <span className="Masthead__details">Camille Camdessus, Paloma Dupont de Dinechin, Tom Février, Marius Gatoux, Baptiste Mezerette, Anahit Miridzhanian, Marie Sasin & Marilou Therre <a href="//twitter.com/sciencespoEDJ" className="twitter-follow-button" data-show-count="false" data-lang="fr" data-dnt="true">Suivre</a></span>
                </div>
                <div className="Masthead__item">
                    <span className="Masthead__label white">Développeur</span>
                    <span className="Masthead__details">Raphaël Dardeau<a href="//twitter.com/iron_dev" className="twitter-follow-button" data-show-count="false" data-lang="fr" data-dnt="true">Suivre</a></span>
                </div>
                <div className="Masthead__item Masthead__item--full">
                    <span className="Masthead__details"><span className="Masthead__label white">Photos :</span> Collections personnelles d'Axel Reymond & Magali Merino, archives L'Equipe</span>
                </div>
                <div className="Masthead__item Masthead__item--full">
                    <span className="Masthead__details"><span className="Masthead__label white">Remerciements :</span> Axel Reymond, Magali, Yohan & Thomas Merino, Nathalie Reymond, Stéphane Lecat, Matthieu Ben Rahou, Grégory Blachier, Marie-France L'Hériteau, Minji Suh, Ecole de Journalisme de Sciences Po</span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Masthead/Masthead.js